
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#000","d":"M17.704 15.89a.932.932 0 01-.468-.14.947.947 0 01-.496-.82.963.963 0 011.928 0 .948.948 0 01-.495.82.936.936 0 01-.469.14zm-5.514-5.316l-.824.002V8.312c0-.11.091-.2.203-.2h1.734c.452 0 .876.213 1.143.575l1.36 1.841c.05.07.002.166-.083.16a53.091 53.091 0 00-3.533-.114zm-1.939-.093c0 .055-.048.1-.104.101-1.235.01-2.336.024-3.276.043-.08.002-.124-.085-.082-.153l1.014-1.677a1.418 1.418 0 011.215-.684h1.03c.112 0 .203.09.203.201v2.17zM6.853 15.89a.932.932 0 01-.468-.139.948.948 0 01-.495-.82.963.963 0 011.927 0 .947.947 0 01-.496.82.929.929 0 01-.468.14zm12.988-4.719a32.092 32.092 0 00-1.98-.286 1.029 1.029 0 01-.709-.406l-2.019-2.737a1.828 1.828 0 00-1.47-.74H8.617c-.64 0-1.233.333-1.563.88l-1.682 2.78s-.73.124-1.074.186C3.333 11.021 3 11.59 3 12.251v2.085c0 .782.636 1.414 1.42 1.414h.527A2.082 2.082 0 006.853 17c.853 0 1.586-.516 1.907-1.25h7.038A2.08 2.08 0 0017.704 17c.854 0 1.59-.517 1.908-1.253A1.418 1.418 0 0021 14.333v-1.769c0-.684-.483-1.272-1.159-1.394z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    